import { render, staticRenderFns } from "./CourseShowTabs.vue?vue&type=template&id=4abae2e0&scoped=true&"
import script from "./CourseShowTabs.vue?vue&type=script&lang=js&"
export * from "./CourseShowTabs.vue?vue&type=script&lang=js&"
import style0 from "./CourseShowTabs.vue?vue&type=style&index=0&id=4abae2e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abae2e0",
  null
  
)

export default component.exports